var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
export const ListContext = React.createContext({
    iconSize: 'xs',
});
class List extends React.Component {
    get spacing() {
        const { spacing, size, bordered, noGutter, direction } = this.props;
        if (spacing) {
            return spacing;
        }
        if (noGutter === 'all') {
            return 'none';
        }
        if (bordered && direction !== 'inline') {
            return 'xlarge';
        }
        switch (size) {
            case 'xsmall':
                return 'medium';
            case 'large':
            case 'small':
            default:
                return 'large';
        }
    }
    get horizontalSpacing() {
        const { noGutter, spacing, horizontalSpacing = spacing, direction } = this.props;
        if (horizontalSpacing) {
            return horizontalSpacing;
        }
        if (noGutter === 'horizontal' || noGutter === 'all') {
            return 'none';
        }
        if (direction === 'inline') {
            return 'xlarge';
        }
        return this.spacing;
    }
    get verticalSpacing() {
        const { noGutter, spacing, verticalSpacing = spacing } = this.props;
        if (verticalSpacing) {
            return verticalSpacing;
        }
        if (noGutter === 'vertical' || noGutter === 'all') {
            return 'none';
        }
        return this.spacing;
    }
    BEM() {
        const classArray = ['list'];
        if (this.props.type) {
            classArray.push('list--' + this.props.type);
        }
        if (this.props.type === 'icon') {
            classArray.push('list--icon-position-' + this.props.iconPosition);
        }
        if (this.props.size) {
            classArray.push('list--' + this.props.size);
        }
        if (this.props.direction) {
            classArray.push('list--direction-' + this.props.direction);
        }
        if (this.props.bordered) {
            classArray.push('list--bordered');
            if (this.props.outerBordered) {
                classArray.push('list--outer-bordered');
            }
        }
        if (this.props.fullWidth) {
            classArray.push('list--full-width');
        }
        if (this.horizontalSpacing) {
            classArray.push('list--hor-spacing-' + this.horizontalSpacing);
        }
        if (this.verticalSpacing) {
            classArray.push('list--ver-spacing-' + this.verticalSpacing);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    render() {
        const _a = this.props, { type, icon, iconPosition, size, iconClassName, className, children, bordered, outerBordered, fullWidth, noGutter, spacing, horizontalSpacing, verticalSpacing, direction, ['aria-labelledby']: ariaLabelledBy } = _a, rest = __rest(_a, ["type", "icon", "iconPosition", "size", "iconClassName", "className", "children", "bordered", "outerBordered", "fullWidth", "noGutter", "spacing", "horizontalSpacing", "verticalSpacing", "direction", 'aria-labelledby']);
        const ListElement = this.props.type === 'ordered' ? 'ol' : 'ul';
        const listContextValue = {
            icon: this.props.icon,
            iconSize: this.props.size === 'xsmall' ? 'xxs' : this.props.size === 'large' ? 'sm' : 'xs',
            iconClassName: this.props.iconClassName,
        };
        return (React.createElement(ListContext.Provider, { value: listContextValue },
            React.createElement("div", Object.assign({ className: this.BEM() }, rest),
                React.createElement(ListElement, { className: "list__inner", role: "list", "aria-labelledby": ariaLabelledBy }, this.props.children))));
    }
}
List.defaultProps = {
    outerBordered: true,
    iconPosition: 'top',
    size: 'small',
};
export default List;
